var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResultInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50129_16026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.36761 0 0 5.367 0 12C0 18.6323 5.367 24 12 24C18.6324 24 24 18.633 24 12C24 5.3677 18.633 0 12 0ZM12 22.3256C6.30647 22.3256 1.67442 17.6936 1.67442 12C1.67442 6.30642 6.30647 1.67442 12 1.67442C17.6935 1.67442 22.3256 6.30642 22.3256 12C22.3256 17.6936 17.6935 22.3256 12 22.3256Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 10.0039C11.2887 10.0039 10.7832 10.3041 10.7832 10.7464V16.7645C10.7832 17.1436 11.2887 17.5226 11.9995 17.5226C12.6787 17.5226 13.2315 17.1436 13.2315 16.7645V10.7463C13.2315 10.304 12.6787 10.0039 11.9995 10.0039Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0022 6.28906C11.2756 6.28906 10.707 6.81031 10.707 7.41055C10.707 8.01083 11.2757 8.54788 12.0022 8.54788C12.713 8.54788 13.2817 8.01083 13.2817 7.41055C13.2817 6.81031 12.713 6.28906 12.0022 6.28906Z",
    fill: "#2D2D2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50129_16026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultInfo);
export default __webpack_public_path__ + "static/media/resultInfo.1f1f859a109856cb91fda8e4338e8b1a.svg";
export { ForwardRef as ReactComponent };